import { slugify } from '@/utils/test-ids.helpers';

/** IDs estáticos da página Meus Anúncios (kebab-case, padrão checkout). */
const MY_ADS_TEST_IDS = {
	PAGE: 'my-ads-page',
	CREATE_BUTTON: 'my-ads-create-button',
	ADS_LIST: 'my-ads-list',
	ADS_TABS: 'ads-tabs',
	LOADING_STATE: 'loading-state',
	LOADING_TABS: 'loading-tabs',
	EMPTY_STATE: 'empty-state',
	EMPTY_STATE_CREATE_BUTTON: 'empty-state-create-button',
	ERROR_STATE: 'error-state',
	ERROR_STATE_RETRY_BUTTON: 'error-state-retry-button',
	DEACTIVATE_MODAL: 'deactivate-modal',
	MARK_AS_SOLD_MODAL: 'mark-as-sold-modal',
	DELETE_MODAL: 'delete-modal',
	EDIT_MODAL: 'edit-modal',
	EDIT_MODAL_CANCEL_BUTTON: 'edit-modal-cancel-button',
	EDIT_MODAL_SAVE_BUTTON: 'edit-modal-save-button',
	EDIT_MODAL_TABS: 'edit-modal-tabs',
	EDIT_MOBILE_VIEW: 'edit-mobile-view',
	EDIT_MOBILE_SAVE_BUTTON: 'edit-mobile-save-button',
	EDIT_MOBILE_CANCEL_BUTTON: 'edit-mobile-cancel-button',
	EDIT_MOBILE_TABS: 'edit-mobile-tabs',
	VEHICLE_DATA_TAB: 'vehicle-data-tab',
	VEHICLE_INFO_CARD: 'vehicle-info-card',
	VEHICLE_FORM_FIELDS: 'vehicle-form-fields',
	INPUT_KILOMETERS: 'input-kilometers',
	INPUT_PRICE: 'input-price',
	INPUT_DESCRIPTION: 'input-description',
	CHECKBOX_ARMORED: 'checkbox-armored',
	PHOTOS_TAB: 'photos-tab',
	PHOTO_UPLOAD: 'photo-upload',
	PHOTO_UPLOAD_GRID: 'photo-upload-grid',
	PHOTO_DROPZONE: 'photo-dropzone',
	PHOTO_DROPZONE_BUTTON: 'photo-dropzone-button',
	PHOTO_DROPZONE_INPUT: 'photo-dropzone-input',
	PHOTO_UPLOAD_ALERT: 'photo-upload-alert',
	PHOTO_COVER_BADGE: 'photo-cover-badge',
	EDIT_LOADING_SPINNER: 'edit-loading-spinner',
	UPGRADE_MODAL: 'upgrade-modal',
	PLAN_SELECTION: 'plan-selection',
	PLAN_SELECTION_LOADING: 'plan-selection-loading',
	PLAN_SELECTION_ERROR: 'plan-selection-error',
	PLAN_SELECTION_EMPTY: 'plan-selection-empty',
	UPGRADE_CHECKOUT_PAGE: 'upgrade-checkout-page',
	UPGRADE_CHECKOUT_BACK_BUTTON: 'upgrade-checkout-back-button',
	UPGRADE_CHECKOUT_LOADING: 'upgrade-checkout-loading'
} as const;

const myAdsTestId = {
	adsTab: (tabId: string) => `ads-tab-${tabId}`,
	vehicleCard: (adId: number) => `vehicle-card-${adId}`,
	cardImage: (adId: number) => `card-image-${adId}`,
	cardInfo: (adId: number) => `card-info-${adId}`,
	cardMetrics: (adId: number) => `card-metrics-${adId}`,
	cardPrice: (adId: number) => `card-price-${adId}`,
	cardStatus: (adId: number) => `card-status-${adId}`,
	cardAction: (actionId: string, adId: number) => `card-action-${actionId}-${adId}`,
	cardOptionsMenu: (adId: number) => `card-options-menu-${adId}`,
	cardOptionsMenuTrigger: (adId: number) => `card-options-menu-trigger-${adId}`,
	cardOptionsItem: (itemId: string, adId: number) => `card-options-item-${itemId}-${adId}`,
	optionalsSection: (title: string) => `optionals-section-${slugify(title)}`,
	optionalChip: (optionId: string) => `optional-chip-${optionId}`,
	photoThumbnail: (photoCode: string | number) => `photo-thumbnail-${photoCode}`,
	photoDeleteButton: (photoCode: string | number) => `photo-delete-button-${photoCode}`,
	photoReplaceButton: (photoCode: string | number) => `photo-replace-button-${photoCode}`,
	photoEmptySlot: (index: number) => `photo-empty-slot-${index}`,
	planCard: (planName: string) => `plan-card-${slugify(planName)}`,
	planCardCta: (planName: string) => `plan-card-cta-${slugify(planName)}`,
	loadingSkeleton: (index: number) => `loading-skeleton-${index}`,
	loadingTabSkeleton: (index: number) => `loading-tab-skeleton-${index}`
} as const;

export { MY_ADS_TEST_IDS, myAdsTestId };
